import { DeviceMode, isNodeV2, notEmpty } from '@vedalib/editor'
import * as R from 'ramda'

import { getNodeWithFullChildren } from 'components/Editor/EditorContext/selectors/block'
import { notify } from 'components/uiKit/Notification'
import { NotificationType } from 'components/uiKit/Notification/types'
import { getBlock, getDeviceMode, getSelectedNodeIds } from 'services/Store/Project/selectors'
import store from 'services/Store/store'
import { t } from 'services/Translation'

export const onCopy = async (event?: KeyboardEvent) => {
  const state = store.getState().project
  const block = getBlock(state)
  const selectedNodes = getSelectedNodeIds(state)
  const selection = window.getSelection()
  const isDesktop = getDeviceMode(state) === DeviceMode.desktop

  if (isDesktop && block && selection?.isCollapsed) {
    const nodes = selectedNodes.map((id) => {
      const [root, ...nodes] = getNodeWithFullChildren(block, id)
      const elementIds = [root, ...nodes].map((node) => (isNodeV2(node) ? node.elementId : null))
      const elements = R.pick(elementIds.filter(notEmpty), block.elements)
      return { root, nodes: R.indexBy(R.prop('id'), nodes), elements }
    })
    const buffer = JSON.stringify(nodes, null, 2)

    try {
      event?.preventDefault()
      await navigator.clipboard.writeText(buffer)
      notify({ type: NotificationType.success, message: t('notify.textCopied') })
    } catch (err) {
      notify({ type: NotificationType.error, message: t('notify.copiedError'), duration: 2000 })
    }
  }
}
